// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ApiKeyRead } from "./ApiKeyRead";
import {
  ApiKeyReadFromJSON,
  ApiKeyReadFromJSONTyped,
  ApiKeyReadToJSON,
  ApiKeyReadToJSONTyped,
} from "./ApiKeyRead";

/**
 *
 * @export
 * @interface PageApiKeyRead
 */
export interface PageApiKeyRead {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<ApiKeyRead>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageApiKeyRead interface.
 */
export function instanceOfPageApiKeyRead(value: object): value is PageApiKeyRead {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageApiKeyReadFromJSON(json: any): PageApiKeyRead {
  return PageApiKeyReadFromJSONTyped(json, false);
}

export function PageApiKeyReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PageApiKeyRead {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(ApiKeyReadFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageApiKeyReadToJSON(json: any): PageApiKeyRead {
  return PageApiKeyReadToJSONTyped(json, false);
}

export function PageApiKeyReadToJSONTyped(
  value?: PageApiKeyRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(ApiKeyReadToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
